// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicationValues_root_221LF","title":"ApplicationValues_title_3I1jp","control":"ApplicationValues_control_3vFrH","hint":"ApplicationValues_hint_3i27N"};